export const BATTERY_OBSTACLE_LIGHTNING_EVENT = 'battery-obstacle-lightning'

export type BatteryObstacleLightningEventDetail = {
    obstacleIds: string[]
}
